import { User } from "../../../types/users";
import { delayedApiDispatch } from "./dispatchGetMe";
import { waitForUserData } from "./waitForUserData";

export function waitForCurrentUser(): Promise<User> {
  delayedApiDispatch();
  return new Promise((resolve) => {
    waitForUserData(resolve);
  });
}
